import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import {
  provideRouter,
  Router
} from '@angular/router';
import { routes } from './app/app.routes';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { formlyValidationConfig, MCConfigService, MCEnvironmentsService, MCHttpWrapperService, MCTranslationStateService } from '@maslul/common-services';
import { environment } from './environments/environment';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
//import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { EnvironmentsService } from './app/services/shared/environments.service';
import { ConfigService } from './app/services/shared/config.service';
import { FORMLY_CONFIG, FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng'
import { customFormlyConfig } from './assets/config/formly.config';
import { MCFormisFieldAutoComplete } from '@maslul/common-components';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaLoaderService, ReCaptchaV3Service } from 'ng-recaptcha';
import { CustomTranslateLoader } from './assets/i18n/CustomTranslateLoader';
import { MIHttpWrapperService } from './app/services/shared/http-wrapper.service';

export function ConfigLoader(configService: MCConfigService) {
  return () => configService.load(environment.configFile);
}

export function CustomLoaderFactory(
  http: HttpClient,
  translationStateService: MCTranslationStateService) {

  return new CustomTranslateLoader(http, translationStateService);

}


function initializeAppAndRedirect(
  router: Router,
  translationStateService: MCTranslationStateService
): () => Promise<any> {
  return () => {
    return new Promise<void>((resolve) => {
      translationStateService.setTranslationsLoaded(false);
      router.navigateByUrl('/')
        .then(() => {
          resolve();
        })
        .catch((error) => {
          console.error("נכשלה טעינת התרגומים:", error);
        });
    });

  }
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    provideAnimations(),
    provideRouter(routes),

    {
      provide: MCEnvironmentsService,
      useClass: EnvironmentsService
    },
    {
      provide: MCConfigService,
      useClass: ConfigService
    },
    {
      provide: MCHttpWrapperService,
      useClass: MIHttpWrapperService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigLoader,
      deps: [MCConfigService],
      multi: true
    },


    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppAndRedirect,
      deps: [Router, MCTranslationStateService],
      multi: true
    },

    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: CustomLoaderFactory,
          deps: [HttpClient, MCTranslationStateService]
        }
      }),
      FormlyModule.forRoot(customFormlyConfig),
      FormlyPrimeNGModule
    ),

    MCFormisFieldAutoComplete,
    {
      provide: FORMLY_CONFIG,
      multi: true, useFactory: formlyValidationConfig, deps: [TranslateService]
    },

    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (configService: MCConfigService) => {
        return configService.getConfiguration().recaptchaV3SiteKey;
      },
      deps: [MCConfigService],
    },
    { provide: RecaptchaLoaderService },
    { provide: ReCaptchaV3Service },
  ]

}).catch(err => console.error(err));